import { Box } from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectStatusEnum } from 'generated/resources/graphql'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import {
  statusOptions,
  stringToProjectManagementProjectStatusEnum,
} from '../../../lib/projectStatus'

export interface ProjectStatusProps {
  onChangeValue: (value: ProjectManagementProjectStatusEnum) => void
  values: ProjectStatusValues
  action: string
}

export interface ProjectStatusValues {
  status: ProjectManagementProjectStatusEnum
}

export const ProjectStatusForm = ({ values, onChangeValue, action }: ProjectStatusProps) => {
  const { status } = values

  return (
    <Box gap="s16">
      <Select
        label={i18n.t('project_management.settings.sections.status.label')}
        defaultValue={status}
        options={statusOptions({ action: action })}
        onChange={(value) => onChangeValue(stringToProjectManagementProjectStatusEnum(value))}
      />
    </Box>
  )
}
